import { render, staticRenderFns } from "./TrainingsQuestions.vue?vue&type=template&id=791fd3c1&scoped=true&lang=pug"
import script from "./TrainingsQuestions.vue?vue&type=script&lang=js"
export * from "./TrainingsQuestions.vue?vue&type=script&lang=js"
import style0 from "./TrainingsQuestions.vue?vue&type=style&index=0&id=791fd3c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791fd3c1",
  null
  
)

export default component.exports